import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-auctions',
  templateUrl: './icon-auctions.component.html',
  styleUrls: ['./icon-auctions.component.scss']
})
export class IconAuctionsComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit(): void {
  }

}
